import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { THIET_BI_PHONG_HOP_PREFIX_URL } from './constants/config.thiet-bi-phong-hop'

const ListPageThietBiPhongHop = lazy(
  () => import('./pages/ListPage.ThietBiPhongHop')
)

const ThietBiPhongHopRouter: AppRouterItem[] = [
  {
    path: THIET_BI_PHONG_HOP_PREFIX_URL,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPageThietBiPhongHop />
      </LoadingLazyComponents>
    ),
  },
]

export default ThietBiPhongHopRouter
